var $54a090ef4709cb69$exports = {};
$54a090ef4709cb69$exports = {
    "more": `Plus d\u{2019}\xe9l\xe9ments`
};


export {$54a090ef4709cb69$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
